'use client'
import { useRef } from 'react'
import { Provider } from 'react-redux'
import { makeStore, AppStore } from '@/lib/stores/store'
import { PersistGate } from 'redux-persist/integration/react'
import { persistStore, type Persistor } from 'redux-persist'

export default function StoreProvider({
                                        children
                                      }: {
  children: React.ReactNode
}) {
  const storeRef = useRef<AppStore>()
  const persistorRef = useRef<Persistor>()

  if (!storeRef.current) {
    // Create the store instance the first time this renders
    storeRef.current = makeStore()
    persistorRef.current = persistStore(storeRef.current)
  }

  return (
    <Provider store={storeRef.current}>
      <PersistGate persistor={persistorRef.current!}>
        {children}
      </PersistGate>
    </Provider>
  )
}